import {Helmet} from '@dr.pogodin/react-helmet';
import {Tabs} from 'platform/components';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {MatrixList} from './(sections)/MatrixList/MatrixList';

export function MatrixManagement() {
  const title = i18n.t('page.accounting.labels.accountingMatrixManagement');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate
        data-testid={testIds.settings.accountingMatrixManagement('header')}
        header={{
          title,
        }}
      >
        <Tabs
          data-testid={testIds.settings.accountingMatrixManagement('tabs')}
          tabs={[
            {
              id: 'metadaMatrices',
              title: i18n.t('page.accountingSettings.labels.metada'),
              content: <MatrixList category="matrices-config-from-metada-to-google" />,
            },
            {
              id: 'googleSheetsMatrices',
              title: i18n.t('page.accountingSettings.labels.googleSheets'),
              content: <MatrixList category="matrices-config-from-google-to-metada" />,
            },
          ]}
        />
      </SettingsTemplate>
    </>
  );
}
